export default {
    message: {
        message: "Welcome back, {name}",
        impersonation: "You are ordering on behalf of «{name}»"
    }
}